import * as actions from './app-actions';
import {reducer} from './app-reducer';
import * as selectors from './app-selectors';
import * as types from './app-types';

export const App = {
    ...actions,
    ...selectors,
    ...types,
    reducer,
} as const;

export type {AppState} from './app-reducer';
